import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from './styles';
import { Outlet } from 'react-router-dom';
import { ProtectedLayoutWrapper } from '@entities/auth';
import { Header } from './Header/Header';
export function Layout(props) {
    return (_jsx(ProtectedLayoutWrapper, { children: _jsxs(S.Layout, { children: [_jsx(Header, Object.assign({}, props)), _jsxs(S.Content, { children: [props.children, _jsx(Outlet, {})] })] }) }));
}
